import React from "react";
import {
  Switch,
  Route
} from "react-router-dom";

import './App.css';

import Home from "./Home";
import Page from "./Page";
import Gao from "./apps/Gao";
import PixiTest from "./apps/PixiTest";
import Watermelon from "./apps/Watermelon";



function App() {
  return (
    <div>
      <Switch>
        <Route path={["/blog","/about"]}>
          <Page/>
        </Route>
        <Route path={["/gao"]}>
          <Gao/>
        </Route>
        <Route path={["/pixi"]}>
          <PixiTest/>
        </Route>
        <Route path={["/watermelon"]}>
          <Watermelon/>
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
    </div>
  );
}

export default App;